import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../App";

/**
 * Public "Past Savi residents" strip. Renders only when at least one
 * archived alumni has been opted-in by admin. Privacy-first: shows only
 * first name + nationality flag emoji — never photo, last name or email.
 */
const AlumniWall = () => {
  const [alumni, setAlumni] = useState([]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await axios.get(`${API}/public/alumni-wall`);
        if (!cancelled) setAlumni(res.data?.alumni || []);
      } catch (err) {
        // Public endpoint — silently swallow errors, the section just stays hidden.
        console.warn("Alumni wall fetch failed", err);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  if (alumni.length === 0) return null;

  return (
    <section className="py-12 sm:py-16 px-4 bg-white" data-testid="alumni-wall-section">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-7 sm:mb-9">
          <p className="text-[#C85A38] font-label text-xs tracking-[0.2em] uppercase mb-3">
            The Savi family
          </p>
          <h2 className="font-serif text-2xl sm:text-3xl text-[#2E2A26] mb-2">
            {alumni.length}+ residents have called Savi home
          </h2>
          <p className="text-[#2E2A26]/55 text-sm max-w-md mx-auto">
            Past guests from {new Set(alumni.map((a) => a.iso).filter(Boolean)).size || "many"}+ countries — a quiet roll-call of the people who&apos;ve been part of this little community.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-2 sm:gap-2.5" data-testid="alumni-wall-list">
          {alumni.map((a, idx) => (
            <span
              key={`${a.first_name}-${idx}`}
              className="inline-flex items-center gap-1.5 bg-[#FBF7F1] border border-stone-200/60 rounded-full px-3.5 py-1.5 text-[13px] text-[#2E2A26]/80 hover:bg-[#F4ECE2] transition-colors"
              data-testid={`alumni-chip-${idx}`}
            >
              {a.iso ? (
                // SVG flag from flagcdn.com — renders identically on every OS,
                // unlike unicode flag emojis which fail on Windows / Linux desktops.
                <img
                  src={`https://flagcdn.com/24x18/${a.iso}.png`}
                  srcSet={`https://flagcdn.com/48x36/${a.iso}.png 2x, https://flagcdn.com/72x54/${a.iso}.png 3x`}
                  width="20"
                  height="15"
                  alt=""
                  loading="lazy"
                  className="rounded-sm object-cover flex-shrink-0"
                  aria-hidden="true"
                />
              ) : (
                <span className="text-base leading-none" aria-hidden="true">{a.flag || "🌍"}</span>
              )}
              <span className="font-medium">{a.first_name}</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AlumniWall;
